import CarAttendance from '@/api/car-attendance'
import VehicleProfile from '@/api/vehicle-profile'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return CarAttendance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchVehicle(context) {
    return VehicleProfile.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          setup_transportation_vehicle_info: 'vehicle_id,plate_no,model'
        }
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchDrivers(context, attributes = {}) {
    if (attributes.vehicle_id === '' || attributes.vehicle_id === null) return

    return CarAttendance.getdriverByVehicle({
      params: { vehicle_id: attributes.vehicle_id }
    }).then(response => {
      return Promise.resolve(response)
    })
  }
}
